import React from 'react';

const WineMaker = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
    <path
      d="M11.392 22.723c.2.095.3.143.431.167.105.018.25.018.354 0 .132-.024.231-.072.431-.167C14.777 21.692 22 17.854 22 12.5V8.287c0-.773 0-1.159-.123-1.493a2 2 0 0 0-.519-.777c-.262-.242-.618-.39-1.331-.686l-7.414-3.076c-.226-.094-.34-.141-.456-.16a1 1 0 0 0-.314 0c-.117.019-.23.066-.456.16L3.973 5.33c-.713.296-1.07.444-1.331.686a2 2 0 0 0-.519.777C2 7.128 2 7.514 2 8.287V12.5c0 5.354 7.223 9.192 9.392 10.223Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 16.9a4.4 4.4 0 1 0 0-8.8 4.4 4.4 0 0 0 0 8.8Zm5.5-4.4h-2.2m-6.6 0H6.5M12 9.2V7m0 11v-2.2"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default WineMaker;
